import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { Mail, CheckCircle } from 'lucide-react';
import { requestOtp } from '../../services/authService';
import TextInput from '../../components/ui/TextInput';
import flexbeeLogo from '../../assets/media/flexbee-no-bg.webp';
import {
  PageWrapper,
  ThirdOrb,
  GridOverlay,
  FormCard,
  LogoContainer,
  FormTitle,
  FormSubtitle,
  Form,
  GradientButton,
  SuccessMessage,
  BackLink,
} from './styles';

// /forgot-password ve /create-password aynı akıştır (e-postaya bağlantı); yalnız metinler ayrışır.
// İlk kez girecek kullanıcı "Şifremi Unuttum" demek zorunda kalmasın diye (vMind geri bildirimi, 2026-10-28).
export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const ns = pathname === '/create-password' ? 'createPassword' : 'forgotPassword';
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) return;
    setLoading(true);
    try {
      await requestOtp(trimmed);
      setSent(true);
    } catch {
      // Error toast handled by interceptor
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper>
      <ThirdOrb />
      <GridOverlay />
      <FormCard>
        <LogoContainer>
          <img src={flexbeeLogo} alt="Flexbee" />
        </LogoContainer>
        {sent ? (
          <>
            <SuccessMessage>
              <CheckCircle size={20} />
              {t(`${ns}.success`)}
            </SuccessMessage>
            <BackLink>
              <Link to="/login">{t('forgotPassword.backToLogin')}</Link>
            </BackLink>
          </>
        ) : (
          <>
            <FormTitle>{t(`${ns}.title`)}</FormTitle>
            <FormSubtitle>{t(`${ns}.subtitle`)}</FormSubtitle>
            <Form onSubmit={handleSubmit}>
              <TextInput
                label={t('login.email')}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
              <GradientButton type="submit" disabled={loading}>
                <Mail size={18} />
                {loading ? t('common.loading') : t(`${ns}.submit`)}
              </GradientButton>
            </Form>
            <BackLink>
              <Link to="/login">{t('forgotPassword.backToLogin')}</Link>
            </BackLink>
          </>
        )}
      </FormCard>
    </PageWrapper>
  );
}
